var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 383,
    height: 91,
    viewBox: "0 0 383 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.71 81.65L44.5 87.44H0V3.02002H43.06L44.27 8.81003H6.16V40.65H31.74V46.56H6.16V81.66H45.72L45.71 81.65Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.5 87.44L94.1198 48.73L66.6198 87.44H59.2598L90.4998 43.9L61.1898 3.02002H68.5498L94.1198 38.96L119.57 3.02002H126.93L97.4998 43.9L128.86 87.44H121.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.79 54.15V87.44H165.64V54.15L137.06 3.01001H143.93L168.77 47.75L193.49 3.01001H200.37L171.79 54.15Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M204.96 45.2299C204.96 20.7499 224.26 1.68994 248.86 1.68994C273.46 1.68994 292.76 20.7499 292.76 45.2299C292.76 69.7099 273.46 88.7699 248.86 88.7699C224.26 88.7699 204.96 69.7099 204.96 45.2299ZM286.37 45.2299C286.37 24.1199 269.85 7.47992 248.86 7.47992C227.87 7.47992 211.35 24.1199 211.35 45.2299C211.35 66.3399 227.87 82.9799 248.86 82.9799C269.85 82.9799 286.37 66.3399 286.37 45.2299Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M382.61 90.45L317.6 15.8V87.44H311.45V0L376.46 74.53V3.73999L382.61 2.16998V90.45Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5898 40.5601H41.8398V46.58H66.5898V40.5601Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/logo-main.31ee2e72ea1e57760f8cbb876305a43e.svg";
export { ForwardRef as ReactComponent };